import { render, staticRenderFns } from "./ArquivoDmed.vue?vue&type=template&id=13e933d5&"
import script from "./ArquivoDmed.vue?vue&type=script&lang=js&"
export * from "./ArquivoDmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports